<template>
  <filter-base
    :is-loading="loading"
    @close="$emit('close')"
    @reset-filter="
      resetFilter(showApprovables).then(() => {
        $emit('update')
      })
    "
  >
    <template #skeleton>
      <v-skeleton-loader v-for="index in 4" :key="index" class="mt-2" type="list-item" />
    </template>
    <template #filter>
      <search-filter-input
        v-for="filterNode in filters"
        :key="filterNode.name"
        :filter-node="filterNode"
        :get-selection-for-filter="getSelectionForFilter"
        :update-filter-selection="updateFilterSelection"
        :remove-item-from-filter-selection="removeItemFromFilterSelection"
        :filter-event="trackFilterFunction"
        @update="$emit('update')"
      />
    </template>
  </filter-base>
</template>

<script lang="ts">
import FilterBase from '@/components/filter/FilterBase.vue'
import SearchFilterInput from '@/components/filter/SearchFilterInput.vue'
import useOrderFilter from '@/modules/order/useOrderFilter'
import FilterEvent from '@/modules/tracking/events/filter'
import { storeToRefs } from 'pinia'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'OrderFilter',
  components: { SearchFilterInput, FilterBase },
  props: {
    showApprovables: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close', 'update'],
  setup() {
    const { filters, loading } = storeToRefs(useOrderFilter())
    const resetFilter = useOrderFilter().resetFilter
    const getSelectionForFilter = useOrderFilter().getSelectionForFilter
    const updateFilterSelection = useOrderFilter().updateFilterSelection
    const removeItemFromFilterSelection = useOrderFilter().removeItemFromFilterSelection

    const trackFilterFunction = FilterEvent.GetFor('orders')('Default')

    return {
      filters,
      loading,
      resetFilter,
      getSelectionForFilter,
      updateFilterSelection,
      removeItemFromFilterSelection,
      trackFilterFunction
    }
  }
})
</script>
